import LetterAvatar from "@/components/Avatar/LetterAvatar"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import StatusBadge from "@/components/ui/badge"
import CodeFormat from "@/components/ui/code"
export const columns = [
  {
    header: "Supplier",
    cell: ({ row }) => <LetterAvatar name={row.original.supplier?.name} />,
  },
  {
    header: "Reference No",
    accessorKey: "reference_number",
  },
  // {
  //   header: "Date",
  //   accessorKey: "date",
  // },
  {
    header: "Date",
    accessorKey: "date_nepali",
  },
  {
    header: "Total Amount",
    cell: ({ row }) => `Rs. ${row.original.total_amount}`,
  },
]
